export default {
  "adminSignIn": "Inicio de sesión de administrador",
  "and": "y",
  "asMeasuredIn": "medida en",
  "authPin": "Autenticar el PIN",
  "battery": "batería",
  "charactersRemaining": "Caracteres Restantes",
  "checkEmail": "Revise su correo electrónico",
  "checkEmailPin": "Para iniciar sesión, revise su correo electrónico y busque un PIN de 5 dígitos.",
  "checkYourEmailForSpecialLink": "Revise su correo electrónico para acceder al enlace especial que le permitirá Iniciar sesión en su cuenta sin tener que recordar una contraseña.",
  "closeDialog": "Cerrar diálogo",
  "closeDialogWindow": "Cerrar ventana de diálogo",
  "computeCapacityLineOne": "Reduciendo las emisiones de carbono",
  "computeCapacityLineTwo": "con capacidad informática.",
  "email": "Correo electrónico",
  "enterCode": "Ingresa el código",
  "enterEmail": "Ingrese su correo electrónico",
  "enterFirstName": "Ingrese su Nombre",
  "enterLastName": "Ingrese su Apellido",
  "enterPassword": "Ingrese su contraseña",
  "enterPin": "Ingrese el PIN",
  "errorLoggingIn": "Error al ingresar",
  "errorSendingLink": "Error al enviar el enlace",
  "errorSendingLinkMessage": "Hubo un error al enviarle un enlace mágico. Por favor, ingrese su correo electrónico en la siguiente página.",
  "ev": "VE",
  "evse": "equipo de servicio de vehículos eléctricos",
  "expiredLinkMessage": "Parece que intentó ingresar con un enlace caducado. Para que le enviemos un nuevo enlace, ingrese de nuevo su correo electrónico.",
  "exportCsvFile": "Exportar archivo CSV",
  "failedLogin": "Su intento de ingresar ha fallado.",
  "filters": "Filtros",
  "firstName": "Nombre",
  "forgotPassword": "¿Has olvidado tu contraseña?",
  "from": "desde",
  "graphDescription": "Descripción del gráfico",
  "here": "aquí",
  "hoSignIn": "Inicio de sesión del propietario",
  "hwh": "calentador de agua",
  "ifYouNeedHelpPleaseClick": "Si necesita ayuda, haga clic",
  "incorrectEmailOrPassword": "Ha intentado ingresar con un correo electrónico o una contraseña incorrectos.",
  "itPlots": "traza",
  "justNeedAFewDetails": "Solo se necesitan algunos detalles para que su cuenta esté lista para usar.",
  "kW": "kilovatios",
  "kwh": "kilovatios hora",
  "lastName": "Apellido",
  "loading": "Cargando",
  "lockedOut": "Hemos bloqueado su ingreso porque ha intentado ingresar demasiadas veces. Puede intentar ingresar nuevamente en 15 minutos.",
  "loginErrorMessage": "Hubo un error al intentar ingresar. Si necesita ayuda, haga clic aquí o comuníquese con nosotros al {supportEmail}.",
  "loginInFirstTime": "Si esta es la primera vez que va a iniciar sesión, use el acceso de Secure Link.",
  "logout": "Cerrar sesión",
  "magicLink": "Su enlace mágico debería llegar a su buzón de correo electrónico en breve. Ahora puede cerrar la ventana de navegación.",
  "noData": "Sin Datos",
  "noResults": "No hay Resultados",
  "off": "Apagado",
  "on": "Encendido",
  "orContactUsAt": "o comuníquese con nosotros al",
  "overTime": "en el tiempo",
  "password": "Contraseña",
  "rac": "acondicionador de aire de la habitación",
  "resetPassword": "Restablecer Contraseña",
  "resetPasswordMessage": "Ingrese su correo electrónico y le enviaremos un enlace para restablecer su contraseña. Para más ayuda, envíe un correo electrónico a ",
  "result": "Resultado",
  "results": "Resultados",
  "s": "segundos",
  "search": "Buscar",
  "seconds": "segundos",
  "sendPin": "Enviarme un PIN",
  "sendSecureLink": "Enviar Secure Link",
  "setupAccount": "Configurar la cuenta",
  "show": "Mostar",
  "sign": "Iniciar sesión",
  "signIn": "Iniciar sesión",
  "signInEmailAndPassword": "Inicie sesión con su correo electrónico y contraseña.",
  "signInLink": "Inicie sesión con un enlace especial que se envió al correo electrónico ingresado a continuación.",
  "signInPassword": "Ingrese con una contraseña",
  "smartGrid": "Mejorando el CI de Smart Grid...",
  "theCapacityOfYour": "la capacidad de tu",
  "theEnergyConsumptionOfYour": "el consumo de energía de tu",
  "theModeSetOnYour": "el modo establecido en tu",
  "thePowerConsumedByYour": "la potencia consumida por tu",
  "thermostat": "termostato",
  "thereWasAnErrorLoggingIn": "Hubo un error cuando intentabas iniciar sesión.",
  "theTemperatureAtYour": "la temperatura en tu",
  "thisGraphShows": "Este gráfico muestra",
  "time": 'Tiempo',
  "toATime": "hasta las",
  "tryAgain": "Intente de nuevo",
  "twoFactorAuth": "Autenticación de dos factores",
  "usePassword": "Use la contraseña",
  "useSecureLink": "¿Usar un enlace seguro?",
  "utilitySignIn": "Inicio de sesión de Utilidad",
  "verify": "Verificar",
  "verifyIdentityMessage": "Verifique su identidad ingresando el código de 6 dígitos de la aplicación de autenticación en su dispositivo.",
  "youAreAllSet": "Estás listo",
  "gravitySignIn": "Inicio de sesión de desarrollador",
};
